import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {Agency, AgencyFormData} from "../../entities/Agency.ts";

export class CreateAgencyUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {

    }
    async execute(data: AgencyFormData): Promise<Agency> {
        return this.agencyRepository.createAgency(data);
    }
}
